
/**
 * Stops event bubbling - click event etc
 */
export default function stopEvent() {
    return {
        restrict: 'A',
        link: (scope, element) => {
            element.bind('click', e => {
                e.stopPropagation();
            });
        }
    };
};